import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c(VBreadcrumbs,{staticClass:"breadcrumb-area",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{attrs:{"to":props.item.href}},[_vm._v(" "+_vm._s(props.item.text))])]}}],null,false,2185830062)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }